<div tabindex="0" class="phx-collapse-item-header" (click)="headerClick()" (keydown.enter)="headerClick()" (keydown.space)="headerClick()">
  <ng-container *ngIf="isCompact; else nonCompactHeader">
    <ng-container *ngTemplateOutlet="headerTextTemplate"></ng-container>
  </ng-container>
  <ng-template #nonCompactHeader>
    <ng-container *ngIf="isHeaderTemplate; else defaultHeader">
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </ng-container>
    <ng-template #defaultHeader>
      <ng-container *ngTemplateOutlet="headerTextTemplate"></ng-container>
    </ng-template>
  </ng-template>
</div>
<div class="phx-collapse-item-content" [@collapseMotion]="phxActive ? 'expanded' : 'hidden'">
  <ng-content></ng-content>
</div>

<ng-template #headerTextTemplate>
  <div class="phx-collapse-item-header-text">
    <span *ngIf="!isCompact">{{ phxHeader }}</span>
    <div class="phx-collapse-item-icon-container">
      <phx-divider *ngIf="isCompact" class="phx-collapse-item-icon-line"></phx-divider>
      <i *ngIf="!isHeaderTemplate" phx-icon class="phx-collapse-item-icon" [phxIcon]="ChevronDownIcon" [size]="collapseIconSize" color="currentColor"></i>
      <phx-divider *ngIf="isCompact" class="phx-collapse-item-icon-line"></phx-divider>
    </div>
  </div>
  <span *ngIf="shouldShowSubtext" class="phx-collapse-item-subtext">{{ phxSubtext }}</span>
</ng-template>
